export const getAllGendersEndpoint = 'genders';
